/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type evidenceDetail_activeTags = {
    readonly activeTagsWithIds: ReadonlyArray<{
        readonly id: string;
        readonly text: string;
    }>;
    readonly " $refType": "evidenceDetail_activeTags";
};
export type evidenceDetail_activeTags$data = evidenceDetail_activeTags;
export type evidenceDetail_activeTags$key = {
    readonly " $data"?: evidenceDetail_activeTags$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"evidenceDetail_activeTags">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "evidenceDetail_activeTags",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TagWithId",
      "kind": "LinkedField",
      "name": "activeTagsWithIds",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};
(node as any).hash = '2b2c940255a96e7a2763188694cba101';
export default node;
